<block-ui [delayStart]="0" [delayStop]="0" [template]="blockTemplate" [class]="template">
  <div
    class="registro-page"
    [ngClass]="'registro-page--' + cardPosition"
    [style.backgroundImage]="'url(' + imagen + ')'">

    <div class="registro-page__overlay"></div>

    <main class="registro-card" role="main" [class.registro-card--datos]="currentStep === 2" aria-label="Registro Atlas Conmigo">
      <div class="registro-card__scroll" #registroScroll>
        <header class="registro-card__header">
          <button type="button" class="brand-button" (click)="regresarLogin()" aria-label="Volver al inicio de sesión">
            <img src="assets/img/icono-atlas.png" alt="Atlas Conmigo" class="brand-button__logo">
            <span class="brand-button__text">
              <strong>Atlas</strong>
              <small>Conmigo</small>
            </span>
          </button>

          @if (currentStep !== 3) {
            <div class="login-access">
              <span>¿Ya tienes cuenta?</span>
              <button type="button" (click)="regresarLogin()">Inicia sesión</button>
            </div>
          }
        </header>

        @if (currentStep !== 3) {
          <nav class="registro-steps" aria-label="Progreso del registro">
            @for (step of steps; track step) {
              <button
                type="button"
                class="registro-step"
                [class.registro-step--active]="isStepActive(step.index)"
                [class.registro-step--completed]="isStepCompleted(step.index)"
                [disabled]="!canNavigateToStep(step.index)"
                (click)="goToStep(step.index)">
                <span class="registro-step__circle">
                  @if (isStepCompleted(step.index)) {
                    <mat-icon>check</mat-icon>
                  }

                  @if (!isStepCompleted(step.index)) {
                    <span>{{ step.index }}</span>
                  }
                </span>

                <span class="registro-step__label">{{ step.label }}</span>
              </button>
            }
          </nav>
        }

        <section class="registro-card__content">
          @switch (currentStep) {
            @case (1) {
              <div class="hero-copy">
                <h1>Únete a <span>Atlas Conmigo</span></h1>
                <p>Regístrate y descubre todo lo que podemos hacer por ti.</p>
              </div>
              <section class="profile-section">
                <h2>Selecciona tu perfil para comenzar</h2>
                <div class="profiles-grid" role="radiogroup" aria-label="Selecciona tu perfil">
                  @for (profile of profiles; track trackByProfile($index, profile)) {
                    <button
                      type="button"
                      class="profile-card"
                      role="radio"
                      [class.profile-card--selected]="selectedProfile === profile.key"
                      [attr.aria-checked]="selectedProfile === profile.key"
                      [attr.aria-label]="profile.label + '. ' + profile.description"
                      (click)="selectProfile(profile.key)">
                      @if (selectedProfile === profile.key) {
                        <span class="profile-card__check">
                          <mat-icon>check</mat-icon>
                        </span>
                      }
                      <span class="profile-card__icon">
                        <mat-icon>{{ profile.icon }}</mat-icon>
                      </span>
                      <span class="profile-card__label">{{ profile.label }}</span>
                    </button>
                  }
                </div>
              </section>
              <section class="benefits-panel" aria-label="Beneficios del registro">
                <div class="benefits-panel__list">
                  @for (benefit of benefits; track benefit) {
                    <div class="benefit-item">
                      <span class="benefit-item__icon">
                        <mat-icon>check</mat-icon>
                      </span>
                      <span>{{ benefit }}</span>
                    </div>
                  }
                </div>
                <div class="benefits-panel__illustration" aria-hidden="true">
                  <mat-icon>assignment_turned_in</mat-icon>
                </div>
              </section>
              <button type="button" class="primary-action" (click)="comenzarRegistro()">
                Comenzar mi registro
              </button>
            }
            @case (2) {
              @switch (selectedProfile) {
                @case ('Ag') {
                  <app-registro-agente-form
                    (formularioModificado)="actualizarEstadoFormulario($event)"
                    (regresarPerfil)="regresarAPerfil()"
                    (registroCompletado)="irAConfirmacion($event)">
                  </app-registro-agente-form>
                }
                @case ('AgUdi') {
                  <app-registro-agente-form
                    tipoRegistro="AgUdi"
                    (formularioModificado)="actualizarEstadoFormulario($event)" 
                    (regresarPerfil)="regresarAPerfil()"
                    (registroCompletado)="irAConfirmacion($event)">
                  </app-registro-agente-form>
                }
                @case ('Proveedor') {
                  <app-registro-proveedor-promotor-form
                    tipoRegistro="Proveedor"
                    (formularioModificado)="actualizarEstadoFormulario($event)"
                    (regresarPerfil)="regresarAPerfil()"
                    (registroCompletado)="irAConfirmacion($event)">
                  </app-registro-proveedor-promotor-form>
                }
                @case ('Promotor') {
                  <app-registro-proveedor-promotor-form
                    tipoRegistro="Promotor"
                    (formularioModificado)="actualizarEstadoFormulario($event)"
                    (regresarPerfil)="regresarAPerfil()"
                    (registroCompletado)="irAConfirmacion($event)">
                  </app-registro-proveedor-promotor-form>
                }
                @case ('A') {
                  <app-registro-asegurado-form
                    (formularioModificado)="actualizarEstadoFormulario($event)"
                    (regresarPerfil)="regresarAPerfil()"
                    (registroCompletado)="irAConfirmacion($event)">
                  </app-registro-asegurado-form>
                }
                @case ('Reasegurador') {
                  <app-registro-reasegurador-form
                    (formularioModificado)="actualizarEstadoFormulario($event)"
                    (regresarPerfil)="regresarAPerfil()"
                    (registroCompletado)="irAConfirmacion($event)">
                  </app-registro-reasegurador-form>
                }
                @case ('Ejecutivo') {
                  <app-registro-empleado-ejecutivo-form
                    tipoRegistro="Ejecutivo"
                    (formularioModificado)="actualizarEstadoFormulario($event)"
                    (regresarPerfil)="regresarAPerfil()"
                    (registroCompletado)="irAConfirmacion($event)">
                  </app-registro-empleado-ejecutivo-form>
                }
                @case ('Empleado') {
                  <app-registro-empleado-ejecutivo-form
                    tipoRegistro="Empleado"
                    (formularioModificado)="actualizarEstadoFormulario($event)"
                    (regresarPerfil)="regresarAPerfil()"
                    (registroCompletado)="irAConfirmacion($event)">
                  </app-registro-empleado-ejecutivo-form>
                }
                @default {
                  <section class="step-placeholder">
                    <span class="step-placeholder__icon">
                      <mat-icon>description</mat-icon>
                    </span>
                    <h1>Datos de registro</h1>
                    <p>
                      El formulario para este perfil se integrará en una siguiente fase.
                    </p>
                    <strong>Perfil seleccionado: {{ selectedProfile }}</strong>
                    <div class="step-placeholder__actions">
                      <button type="button" class="secondary-action" (click)="regresarAPerfil()">
                        Regresar a perfil
                      </button>
                    </div>
                  </section>
                }
              }
            }
            @case (3) {
              <section class="step-placeholder step-placeholder--success">
                <span class="step-placeholder__icon step-placeholder__icon--success">
                  <mat-icon>check_circle</mat-icon>
                </span>
                <h1>Usuario registrado</h1>
                <p>
                  El usuario <strong>{{ usuarioRegistrado }}</strong> se registró exitosamente
                  como <strong>{{ nombrePerfilSeleccionado }}</strong>.

                  Ya puedes iniciar sesión en Atlas Conmigo. Se le envió un correo de
                  confirmación de registro a la dirección de correo electrónico proporcionada.
                </p>
                <div class="step-placeholder__actions">
                  <button type="button" class="primary-action" (click)="regresarLogin()">
                    Iniciar sesión
                  </button>
                </div>
              </section>
            }
          }
        </section>

        @if (currentStep === 1) {
          <div class="registro-card__footer">
            <p>
              Al continuar aceptas nuestro
              <button type="button" (click)="abrirAvisoPrivacidad()">Aviso de Privacidad</button>
              y
              <button type="button" (click)="abrirContactanos()">Contáctanos</button>
            </p>
            <div class="trust-strip" aria-label="Información del proceso">
              <div class="trust-item">
                <mat-icon>computer</mat-icon>
                <span>Proceso 100%<br>en línea</span>
              </div>
              <div class="trust-item">
                <mat-icon>verified_user</mat-icon>
                <span>Fácil, rápido<br>y seguro</span>
              </div>
              <div class="trust-item">
                <mat-icon>business</mat-icon>
                <span>Respaldado por<br>Seguros Atlas</span>
              </div>
            </div>
          </div>
        }
      </div>
    </main>
  </div>
</block-ui>

